"use client";
import { jsxs as a, jsx as l } from "react/jsx-runtime";
const s = ({
  title: i,
  titleId: h,
  desc: d,
  descId: f,
  ...e
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-sg",
    viewBox: "0 0 640 480",
    "aria-labelledby": h,
    "aria-describedby": f,
    ...e,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: f, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: h, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "sg-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M0 0h640v480H0z" }) }) }),
      /* @__PURE__ */ a("g", { fillRule: "evenodd", clipPath: "url(#sg-a)", children: [
        /* @__PURE__ */ l("path", { fill: "#fff", d: "M-20 0h720v480H-20z" }),
        /* @__PURE__ */ l("path", { fill: "#df0000", d: "M-20 0h720v240H-20z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            d: "M146 40.2a84.4 84.4 0 0 0 .8 165.2 86 86 0 0 1-106.6-59 86 86 0 0 1 59-106c16-4.6 30.8-4.7 46.9-.2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            d: "m133 110 4.9 15-13-9.2-12.8 9.4 4.7-15.2-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.5 52 5 15.1-13-9.2-12.9 9.3 4.8-15.1-12.8-9.4 15.9-.1 4.9-15.1 5 15h16zm58.5-.4 4.9 15.2-13-9.3-12.8 9.3 4.7-15.1-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.4-51.6 4.9 15.1-13-9.2-12.8 9.3 4.8-15.1-12.9-9.4 16-.1 4.8-15.1 5 15h16zm-46.3-34.3 5 15.2-13-9.3-12.9 9.4 4.8-15.2-12.8-9.4 15.8-.1 5-15.1 5 15h16z"
          }
        )
      ] })
    ]
  }
);
export {
  s as default
};
